import moment from 'moment-timezone';

// Source expiry is exclusive: midnight means the preceding day is the last valid day.
export const coinValidityDate = (value: string | Date, format = 'D MMM YYYY'): string => {
  const date = typeof value === 'string' ? moment.parseZone(value) : moment(value).tz('Europe/Tallinn');
  if (date.hour() === 0 && date.minute() === 0 && date.second() === 0 && date.millisecond() === 0) date.subtract(1, 'day');
  return date.format(format);
};
